import { GdsServiceRestrictionType } from '@websky/graphql';
const keyByRestrictionType = {
    [GdsServiceRestrictionType.byRfiscPerOrder]: 'rfisc',
    [GdsServiceRestrictionType.byRfiscPerSegment]: 'rfisc',
    [GdsServiceRestrictionType.byTypePerOrder]: 'type',
    [GdsServiceRestrictionType.byTypePerSegment]: 'type',
    [GdsServiceRestrictionType.bySubTypePerOrder]: 'subType',
    [GdsServiceRestrictionType.bySubTypePerSegment]: 'subType'
};
export function getGdsServicesCalculatedCountInfoSelector(passengerIds, segmentIds, gdsServicesRestrictions, selectedServicesByType) {
    const result = {};
    for (const passengerId of passengerIds) {
        if (!result[passengerId]) {
            result[passengerId] = {};
        }
        const passengerSelected = selectedServicesByType[passengerId];
        for (const segmentId of segmentIds) {
            if (!result[passengerId][segmentId]) {
                result[passengerId][segmentId] = { rfisc: {}, type: {}, subType: {} };
            }
            gdsServicesRestrictions.forEach(restriction => {
                const restrictionType = restriction.restrictionType;
                const restrictionMaxCount = restriction.maxCount;
                const key = keyByRestrictionType[restrictionType];
                const isRestrictionPerOrder = restrictionType === GdsServiceRestrictionType.byRfiscPerOrder ||
                    restrictionType === GdsServiceRestrictionType.byTypePerOrder ||
                    restrictionType === GdsServiceRestrictionType.bySubTypePerOrder;
                const restrictionPerType = isRestrictionPerOrder ? 'order' : 'segment';
                const selectedTotalCount = restriction.value.reduce((count, value) => {
                    var _a, _b, _c, _d, _e, _f, _g;
                    // tslint:disable-next-line:restrict-plus-operands
                    return count +
                        (isRestrictionPerOrder
                            ? (_c = (_b = (_a = passengerSelected === null || passengerSelected === void 0 ? void 0 : passengerSelected.total) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b[value]) !== null && _c !== void 0 ? _c : 0
                            : (_g = (_f = (_e = (_d = passengerSelected === null || passengerSelected === void 0 ? void 0 : passengerSelected.segments) === null || _d === void 0 ? void 0 : _d[segmentId]) === null || _e === void 0 ? void 0 : _e[key]) === null || _f === void 0 ? void 0 : _f[value]) !== null && _g !== void 0 ? _g : 0);
                }, 0);
                restriction.value.forEach(value => {
                    result[passengerId][segmentId][key][value] = {
                        maxCount: restrictionMaxCount,
                        selectedCount: selectedTotalCount,
                        diffCount: restrictionMaxCount - selectedTotalCount,
                        restrictionValue: restriction.value,
                        restrictionType,
                        restrictionPerType,
                        key
                    };
                });
            });
        }
    }
    return result;
}
